import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { LoadStatusCell } from "~/shared/components/trax-grid/load-status-cell/load-status-cell.tsx";
import { LoaderCell } from "~/shared/components/trax-grid/loader-cell/loader-cell.tsx";

import { useLoadCellContext } from "../../utils/load-cell-context.tsx";

/**
 * Stable module-level cell renderer for the Status column. Reads runtime
 * config (isLoading, isInternal) from `LoadCellContext` so its function
 * reference stays identical across renders — preventing Kendo from
 * unmounting and remounting every cell when column prefs change.
 */
export const StatusCell = (props: GridCustomCellProps) => {
	const { isLoading, isInternal } = useLoadCellContext();
	return isLoading ? (
		<LoaderCell {...props} />
	) : (
		<LoadStatusCell {...props} isInternal={isInternal} />
	);
};
